import React, { useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Logo from "../../../Assets/Images/logo.svg";
import { Link, NavLink, useLocation } from "react-router-dom";
import Dashboardd from "../../../Assets/Images/Dashboard";
import Profile from "../../../Assets/Images/Profile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "../Home";
import { getBranding } from "../../../utils/getBranding";

const drawerWidth = 240;

function UnauthorizedDashboard(props) {
  const { window } = props;
  const branding = getBranding();
  // const details = localStorage.getItem('userdetails')
  // const user =  JSON.parse(details)
  const location = useLocation();
  console.log(location);
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [sidebar, setSidebar] = useState([
    {
      name: "Dashboards",
      icon: <Dashboardd />,
      link: "/dashboard",
      id: "dashbord",
    },
  ]);
  const drawer = (
    <div>
      {/* <div className=" pt-2 border-b border-b-gray-300 mb-2 pb-4 bg-[#F8FAFC]  ">
        <img src={branding.logo} alt="logo" className="  mx-auto" />
      </div> */}
<div className="pt-2 border-b border-b-gray-300 mb-2 pb-4 bg-[#F8FAFC]">
  <img
    src={branding.logo}
    alt="logo"
    className={`mx-auto ${branding.brandName === "Olumajek IT Continental" ? "h-10 w-auto" : "h-16 w-auto"}`}
  />
</div>

      {/* <List>
        {sidebar.map((text, index) => (
          <NavLink
            className={({ isActive }) => {
              return (
                " block  p-3 mb-3 pl-6 " +
                (!isActive
                  ? " block "
                  : " flex mt-[5px] text-[#2948CE] bg-secondary/[0.2] items-center p-3 rounded sidebar")
              );
            }}
            to={text.link}
          >
            <div className=" flex">
              {text.icon}
              <span className=" pl-3">{text.name}</span>
            </div>
          </NavLink>
        ))}
      </List> */}
      <List>
  {sidebar.map((text, index) => (
    <NavLink
      key={index}
      to={text.link}
      className={({ isActive }) =>
        `block p-3 mb-3 pl-6 rounded ${
          isActive ? 'flex mt-[5px] items-center sidebar' : ''
        }`
      }
      style={({ isActive }) =>
        isActive
          ? {
              backgroundColor: branding.color.secondary + '20', // 12% opacity
              color: branding.color.secondary,
            }
          : {}
      }
    >
      <div className="flex">
        {text.icon}
        <span className="pl-3">{text.name}</span>
      </div>
    </NavLink>
  ))}
</List>


      <div className=" mt-[500px]">
        {/* Privacy Policy Link */}
        <div className="text-center mb-3">
          <Link 
            to="/privacy-policy" 
            className="text-[14px] hover:underline"
            style={{ color: branding.color.primary }}
          >
            Privacy & Policy
          </Link>
        </div>
        
        {/* Copyright */}
        <p className="text-center text-[14px]" style={{ color: branding.color.primary }}>
          ©️ 2025 - {branding.brandName}
        </p>
      </div>
    </div>
  );
  const convertToTitleCase = (text) => {
    if (!text || typeof text !== 'string') return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;
  return (
    <div>
      <ToastContainer />

      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            backgroundColor: "#F8FAFC",
          }}
        >
          <div className=" flex justify-between">
            <div className=" flex justify-between">
              <Toolbar>
                <IconButton
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { sm: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
              </Toolbar>
              <div className=" flex flex-col justify-center">
                <p className=" text-black md:text-[24px] capitalize font-[400]">
                  Welcome
                  {/* {convertToTitleCase(user.firstName)}  */}
                </p>
              </div>
            </div>

            <div className=" md:flex hidden justify-center gap-2">
              <div className=" flex flex-col justify-center"></div>

              <div className="pt-5 relative">
                <div className="absolute top-4 right-1">
                  <Profile />
                </div>
              </div>

              <div
                className=" mt-3 flex gap-2 mr-3 relative cursor-pointer"
                onClick={() => setOpen(!open)}
              >
                <div>
                  {/* <p className=' px-3 py-2 rounded-[44px] bg-back-color2'> {Array.from(user.lastName)[0]}</p>  */}
                </div>

                <div>
                  {/* <p className=' text-black inline-block mt-1 font-bold text-[16px] mr-4'>{convertToTitleCase(user.firstName)}  {convertToTitleCase(user.lastName)} </p> */}
                </div>
              </div>
            </div>
          </div>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "white",
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "white",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <div className=" w-full  h-screen">
            <Home />
          </div>
        </Box>
      </Box>
    </div>
  );
}
UnauthorizedDashboard.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default UnauthorizedDashboard;
